import type { CircularProgressProps } from '@mui/material/CircularProgress';
import CircularProgress from '@mui/material/CircularProgress';
import type { CSSProperties, FC } from 'react';
import { styled } from '@mui/material';

export interface LoaderProps extends CircularProgressProps {
  position?: CSSProperties['position'];
  size?: number;
}

export const LoaderContainer = styled('div')<LoaderProps>(({ position }) => ({
  position: position || 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const Loader: FC<LoaderProps> = ({ position, ...props }) => {
  return (
    <LoaderContainer position={position}>
      <CircularProgress {...props} aria-label='Loading' />
    </LoaderContainer>
  );
};
